import React from 'react';
import {Flex, SVGButton} from '/app/src/component';
import style from './style.css';
import DateTime from '/app/src/lib/DateTime';

class TicketPreview extends React.Component {
    render() {
        if(!this.props.ticket) return null;
        if(!this.props.ticket.info) return null;

        const ticket = this.props.ticket.info.payload
        const dateResolved = DateTime.getDetailedNiceDate(ticket.date_resolved)

        return (
            <Flex className={style.PreviewWrapper} width='100%' center shrink={0}>
                <SVGButton
                    src='/images/Menu_Conversations.svg'
                    hover='grey'
                    color='grey'
                    height='60px'/>

                <Flex className={style.PreviewBody} column grow>
                    <Flex className={style.BodyInfo} width='100%'>
                        <Flex grow vAlignContent='center' fontSize='16px' fontWeight='500' color='black'>
                            Ärende #{ticket.company_ticket_id}
                        </Flex>
                        <Flex paddingRight='10px' hAlignContent='right' vAlignContent='center' fontSize='12px' color='grey' overflow='hidden'>
                            {dateResolved}
                        </Flex>
                    </Flex>
                    <Flex className={style.FirstEntry} width='90%' color='darkgrey' overflow='hidden'>
                        {ticket.first_entry}
                    </Flex>
                </Flex>
            </Flex>
        );
    }
}

export default TicketPreview



// WEBPACK FOOTER //
// ./src/component/Ticket/Preview/index.js